"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marcheno": {
    "420e9cdf": [{
      "hkey": "eb6e3b8f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "aleno": [{
      "hkey": "eb6e3b8f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marcheno"
    }],
    "87e9eb8d": [{
      "hkey": "dd418a2c",
      "slug": "marcheno",
      "name": "Marcheno",
      "primary": true,
      "skipSearch": false
    }],
    "parte": [{
      "hkey": "dd418a2c",
      "slug": "marcheno",
      "name": "Marcheno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1edd4838": [{
      "hkey": "dd418a2c",
      "slug": "marcheno",
      "name": "Marcheno",
      "primary": true,
      "skipSearch": false
    }],
    "rovedolo": [{
      "hkey": "dd418a2c",
      "slug": "marcheno",
      "name": "Marcheno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;